<template>

  <div>

    <div id="input">
      <Input v-bind:preparing="preparing" v-on:asked="ask"/>
    </div>

    <Output v-bind:answer="answer" v-bind:loading="loading"/>

  </div>

</template>

<script>
import Input from '@/components/subcomponents/Input.vue'
import Output from '@/components/subcomponents/Output.vue'

import answersApi from '@/api/answers.js'

export default {
  name: 'InputOutput',

  components: {
    Input,
    Output
  },

  props: {
    preparing: Boolean
  },

  data: function() {
    return {
      loading: false,
      answer: "The answer"
    }
  },
  
  methods: {
    
    ask(question) {
      
      this.loading = true

      answersApi.getAnswerAnd(
        question,
        answer => {
          this.answer = answer
          this.loading = false
        }
      )
      .catch(r => {
        console.log(r)
        this.loading = false
      })

    }

  }
  
}

</script>

<style scoped>

#input {
  padding-bottom: 2vh;
}

</style>
